import Alpine from 'alpinejs'
window.Alpine = Alpine
window.onload = Alpine.start
